import { FC } from 'react'
import { Badge, BadgeProps } from '../Badge'
import { MdOutlineLocalFireDepartment } from 'react-icons/md'

export type BadgeMatchProps = Omit<
  BadgeProps,
  'type' | 'variant' | 'customColors' | 'leftIcon' | 'rightIcon'
>

export const BadgeMatch: FC<BadgeMatchProps> = ({ value, ...restProps }) => {
  return (
    <Badge
      {...restProps}
      value={value}
      rightIcon={
        <MdOutlineLocalFireDepartment className="text-notif-orange min-w-[24px] min-h-[24px]" />
      }
      customColors={{
        bgColor: 'bg-white',
        textColor: 'text-notif-orange'
      }}
    />
  )
}

export default BadgeMatch
